import React from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import "./Navbar.css";

const Navbar = () => {
  const state = useSelector((state) => state.handleCart);

  return (
    <nav className="navbar navbar-expand-lg navbar-light custom-navbar shadow-sm sticky-top">
      <div className="container py-2">
        <NavLink className="navbar-brand fw-bold fs-3 text-dark brand-logo" to="/">
          YOLA <i className="fa fa-heart ms-1 text-danger"></i>
        </NavLink>

        <button
          className="navbar-toggler border-0"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav mx-auto">
            {["Home", "Products", "About", "Contact"].map((item, idx) => (
              <li className="nav-item mx-2" key={idx}>
                <NavLink
                  className="nav-link custom-nav-link fw-semibold text-dark"
                  to={item === "Home" ? "/" : `/${item.toLowerCase()}`}
                >
                  {item}
                </NavLink>
              </li>
            ))}
          </ul>

          <div className="d-flex align-items-center gap-2 ms-auto">
            <NavLink to="/login" className="btn-modern btn-outline px-3">
              <i className="fa fa-sign-in me-1"></i> Login
            </NavLink>
            <NavLink to="/register" className="btn-modern btn-filled px-3">
              <i className="fa fa-user-plus me-1"></i> Register
            </NavLink>
            <NavLink
              to="/cart"
              className="btn-modern btn-filled-cart px-3 position-relative"
            >
              <i className="fa fa-shopping-cart me-1"></i> Cart
              <span className="cart-badge">{state.length}</span>
            </NavLink>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
